import { useState, useEffect  } from 'react';
import { field as S, colors, radius } from './styles';
import { BIBLE_BOOKS } from '../data/bibleBooks';

const TRANSLATORS = [
  "Patterson Kajimalwendo — Zambia (Bemba & Kaonde)",
  "Erique Black — Kenya (Swahili)",
  "Candy Likoko — Kenya (Swahili)",
  "Mary Gill — Pakistan (Urdu)",
  "Asif Masih — Pakistan (Urdu)",
  "Aneel John — Pakistan (Urdu)",
  "J Ratnaraju Raju — India (Telugu)",
  "Raymond Raj — India (Kannada)",
  "Anthu Jeremiah — India (Telugu)",
];

function Field({ label, hint, children }) {
  return (
    <div style={S.wrapper}>
      <label style={S.label}>{label}</label>
      {children}
      {hint && <div style={S.hint}>{hint}</div>}
    </div>
  );
}

export default function VideoForm({ form, onChange }) {
  const set = key => e => onChange(key, e.target.value);

const [bookSearch, setBookSearch] = useState('');
const [showSuggestions, setShowSuggestions] = useState(false);

useEffect(() => {
  if (form.bookId) {
    const selectedBook = BIBLE_BOOKS.find(
      b => String(b.id) === String(form.bookId)
    );

    if (selectedBook) {
      setBookSearch(selectedBook.name);
    }
  }
}, [form.bookId]);

const filteredBooks =
  bookSearch.trim().length > 0
    ? BIBLE_BOOKS.filter(book =>
        book.name.toLowerCase().includes(bookSearch.toLowerCase())
      )
    : [];

const selectBook = book => {
  setBookSearch(book.name);
  onChange('bookId', book.id);
  setShowSuggestions(false);
};

const AUTHOR_DEFAULT = 'Stephen Walkup';

  return (
    <>
      <Field label="Title *">
        <input
          style={S.input}
          value={form.title}
          onChange={set('title')}
          placeholder="Enter video title"
        />
      </Field>

      <Field label="Video Link *">
        <input
          style={S.input}
          value={form.videoLink}
          onChange={set('videoLink')}
          placeholder="https://youtube.com/..."
        />
      </Field>

      <Field label="Publish Status">
        <label style={{
          display: 'flex', alignItems: 'center', gap: 10,
          padding: '10px 12px',
          border: `1px solid ${colors.border}`, borderRadius: radius.md,
          cursor: 'pointer', userSelect: 'none',
        }}>
          <input
            type="checkbox"
            checked={!!form.isPublished}
            onChange={e => onChange('isPublished', e.target.checked)}
            style={{
              width: 16, height: 16, cursor: 'pointer', accentColor: colors.primary,
            }}
          />
          <span style={{ fontSize: 13, color: colors.text }}>
            {form.isPublished ? 'Published' : 'Not published (draft)'}
          </span>
        </label>
      </Field>

      <div style={S.row}>
       <Field label="Language">
  <select
    style={{
      ...S.input,
      appearance: 'none',
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%238892B0' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 12px center',
      paddingRight: 32,
      cursor: 'pointer',
      color: form.language ? colors.text : colors.textHint,
    }}
    value={form.language}
    onChange={set('language')}
  >
    <option value="" style={{ background: '#1C2333', color: '#8892B0' }}>— Select a language —</option>
    {['Bemba','English','Kaonde','Kannada', 'Swahili', 'Tamil','Telugu','Urdu'].map(lang => (
      <option key={lang} value={lang} style={{ background: '#1C2333', color: '#E8EAF6' }}>
        {lang}
      </option>
    ))}
  </select>
</Field>

        <Field label="Book *">
  <div style={{ position: 'relative' }}>
    <input
      style={S.input}
      value={bookSearch}
      placeholder="Type book name (e.g. Peter, Psa, John)"
      onFocus={() => setShowSuggestions(true)}
      onBlur={() => {
        setTimeout(() => setShowSuggestions(false), 150);
      }}
      onChange={e => {
        setBookSearch(e.target.value);
        onChange('bookId', '');
        setShowSuggestions(true);
      }}
    />

    {showSuggestions && filteredBooks.length > 0 && (
      <div
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          marginTop: 4,
          background: '#1C2333',
          border: '1px solid #2A3448',
          borderRadius: radius.md,
          maxHeight: 220,
          overflowY: 'auto',
          zIndex: 1000,
          boxShadow: '0 8px 20px rgba(0,0,0,0.35)',
        }}
      >
        {filteredBooks.map(book => (
          <div
            key={book.id}
            onMouseDown={() => selectBook(book)}
            style={{
              padding: '10px 12px',
              cursor: 'pointer',
              color: '#E8EAF6',
              borderBottom: '1px solid #2A3448',
            }}
          >
            {book.id}. {book.name}
          </div>
        ))}
      </div>
    )}
  </div>
</Field>
      </div>

      <div style={S.row}>
        <Field label="Author">
          <input
            style={S.input}
            value={form?.author || AUTHOR_DEFAULT}
            onChange={set('author')}
            placeholder="Author name"
          />
        </Field>

        <Field label="Lesson">
          <input
            style={S.input}
            value={form.lesson}
            onChange={set('lesson')}
            placeholder="e.g. Lesson 1"
          />
        </Field>
      </div>
      
      
      <Field label="Translator">
        <select
          style={{
            ...S.input,
            appearance: 'none',
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%238892B0' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 12px center',
            paddingRight: 32, cursor: 'pointer',
            color: form.translator ? colors.text : colors.textHint,
          }}
          value={form.translator}
          onChange={set('translator')}
        >
          <option value="" style={{ background: '#1C2333', color: '#8892B0' }}>— Select a translator —</option>
          {TRANSLATORS.map(t => (
            <option key={t} value={t} style={{ background: '#1C2333', color: '#E8EAF6' }}>{t}</option>
          ))}
        </select>
      </Field>

      <Field label="Description">
        <textarea
          style={S.textarea}
          value={form.description}
          onChange={set('description')}
          placeholder="Brief description of the video..."
        />
      </Field>

      <Field
        label="Tags"
        hint="Comma-separated — e.g. faith, prayer, genesis"
      >
        <input
          style={S.input}
          value={form.tags}
          onChange={set('tags')}
          placeholder="faith, prayer, genesis"
        />
      </Field>

      <Field
        label="Chapters"
        hint="Comma-separated chapter numbers — e.g. 1, 2, 3"
      >
        <input
          style={S.input}
          value={form.chapters}
          onChange={set('chapters')}
          placeholder="1, 2, 3"
        />
      </Field>
    </>
  );
}
